export default __webpack_public_path__ + "static/experienceImg5-248c56e6ae6ee553653c6988bc186b9c.webp";